export async function connectFacebookOAuthIntegration(): Promise<boolean> {
  try {
    // Start OAuth flow directly - user ID is handled server-side via session
    const authUrl = `${process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT_URI}/v2/oauth/facebook/authorize`

    return new Promise<boolean>((resolve) => {
      const popup = window.open(
        authUrl,
        'facebook-oauth',
        'width=800,height=800,scrollbars=yes,resizable=yes,left=' +
          (screen.width / 2 - 400) +
          ',top=' +
          (screen.height / 2 - 400)
      )

      if (!popup) {
        resolve(false)
        return
      }

      const checkClosed = setInterval(() => {
        if (popup.closed) {
          clearInterval(checkClosed)
          channel.close()
          resolve(false)
        }
      }, 1000)

      // Listen for OAuth completion message via BroadcastChannel
      const channel = new BroadcastChannel('oauth_channel')
      channel.onmessage = (event) => {
        // Only handle Facebook OAuth messages
        if (!event.data || !event.data.type || !event.data.type.startsWith('FACEBOOK_OAUTH_')) {
          return
        }

        if (event.data.type === 'FACEBOOK_OAUTH_SUCCESS') {
          clearInterval(checkClosed)
          popup.close()
          channel.close()
          resolve(true)
        } else if (event.data.type === 'FACEBOOK_OAUTH_ERROR') {
          clearInterval(checkClosed)
          popup.close()
          channel.close()
          resolve(false)
        }
      }
    })
  } catch (error) {
    console.error('Facebook OAuth connection error:', error)
    return false
  }
}
